<script>
    import { required, maxLength } from "vuelidate/lib/validators";
    import validationMessages from "@/components/validations";
    import Notification from "@/services/Notification";
    import Swal from "sweetalert2";

    export default {
        props:['selectedTenant'],
        components: { validationMessages },

        data() {
            return {
                selectedType: "",
                title: "",
                message: "",
                types:[],
                typeDescription:'',
                selectedLanguage: '',
                attributes:[],
                showModal: false,
                tenant: '',
                submitted: false,
                selectedAttributes:{},
                tryingToSubmit: false,
                showLoader: false,
                csrf_token: localStorage.getItem("csrf_token"),
                error: null,
                langOptions:["EN","NL","FR"]
            };
        },

        validations: {
            selectedType: {
                required,
                maxLength: maxLength(16),
            },
        },
        watch: {
          selectedType(newType) {
            const selectedTypeObject = this.types.find(t => t.type === newType)
            if (!selectedTypeObject) {
              this.attributes     = [];
              this.typeDescription = "";
              return;
            }
            this.attributes = selectedTypeObject.attributes

          },
        },
        computed: {
          attributesList() {
            // Object.values() will give you an array of the inner objects
            return Object.values(this.attributes || {});
          }
        },
        methods: {


            closeModal() {
                this.showModal = false;
                this.resetForm();
            },

            async getTypeNotification() {
                this.showLoader = true;
                try {
                    const response = await Notification.getAutomatedNotificationTypes();
                    this.types = response.data.types
                } catch (error) {
                    console.error("Error fetching types:", error);
                } finally {
                    this.showLoader = false;
                }
            },

            async createAutomatedNotification() {
                this.tryingToSubmit = true;
                this.submitted = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.tryingToSubmit = false;
                    return;
                }
                const attributesObject = {};
                this.attributesList.forEach(({ attribute, value }) => {
                  attributesObject[attribute] = value;
                });
                const payload = {
                  type: this.selectedType,
                  tenant: this.tenant,
                  language: this.selectedLanguage,
                  attributes: attributesObject,
                  csrf_token: this.csrf_token
                };
                try {
                    const response = await Notification.createNotificationSetup(payload);
                    if (response.error) {
                        this.failedmsg(response.error);
                    } else {
                        this.successmsg(response.message);
                        this.closeModal();
                        this.refreshData();
                    }
                } catch (error) {
                    this.error = error.response?.data?.error || "An error occurred";
                    this.failedmsg(this.error);
                } finally {
                    this.tryingToSubmit = false;
                    this.refreshData();
                }
            },

            successmsg(message) {
                Swal.fire("Success", message, "success");
            },

            failedmsg(message) {
                Swal.fire("Error", message, "error");
            },

            refreshData() {
                this.$emit("onRefresh");
            },

            resetForm() {
                this.selectedType = "";
                this.attributes = [];
                this.types = []
                this.submitted = false;
                this.tryingToSubmit = false;
                this.tenant = ''
                this.$v.$reset();
            },

            async modalShown() {
                this.tenant = this.selectedTenant ? this.selectedTenant : process.env.VUE_APP_TENANT
                  console.log(this.tenant);
                await this.getTypeNotification();
            }
        },
    };
</script>


<template>
    <b-modal  @shown="modalShown" id="add_notification_setup" size="l" v-model="showModal" @hidden="resetForm" title="Automated Notification" title-class="font-18">
        <form @submit.prevent="createAutomatedNotification" v-if="!showLoader">
            <div class="row">
                <div v-if="$v.$error" class="text-danger">Complete all fields</div>
                <b-card-text>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-group label="Type" label-for="formrow-selectedType-input" class="mb-3">
                                <b-form-select
                                        v-model="selectedType"
                                        :options="types.map(item => item.type)"
                                        :class="{ 'is-invalid': submitted && $v.selectedType.$error }"
                                ></b-form-select>
                                <validationMessages v-if="submitted" :fieldName="'Notification Type'" :validationName="$v.selectedType"></validationMessages>
                            </b-form-group>
                            <div v-for="(attribute, index) in attributesList"  :key="index">
                                 <label :for="`attr-${attribute.attribute}`" >{{attribute.attribute}}</label>
                                <input
                                    :id="`attr-${attribute.attribute}`"
                                    class="form-control mb-3"
                                    v-model="attribute.value"
                                    :disabled="!attribute.value_editable"
                                />
                            </div>
                            <div>
                               <label>Language</label>
                                <b-form-select
                                    class="form-select"
                                    v-model="selectedLanguage"
                                    :options="langOptions"
                                ></b-form-select>
                            </div>
                           <input type="hidden" name="csrf_token" v-model="csrf_token">
                        </div>
                    </div>
                </b-card-text>
            </div>
        </form>
        <div class="card-body d-flex align-items-center justify-content-center" v-else>
            <b-spinner large></b-spinner>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="createAutomatedNotification" :disabled="tryingToSubmit || showLoader">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
            </b-button>
        </template>
    </b-modal>
</template>
